import * as Sentry from "@sentry/vue";
import { api2 } from "./api";
import store from "../stores/store";

let izipaySdkPromise = null;

export function loadIzipaySdk() {
  if (izipaySdkPromise) return izipaySdkPromise;
  izipaySdkPromise = new Promise((resolve, reject) => {
    if (window.Izipay) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = process.env.VUE_APP_IZIPAY_SDK_URL;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("No se pudo cargar el SDK de Izipay."));
    document.head.appendChild(script);
  });
  return izipaySdkPromise;
}

const getIzipaySession = async () => {
  const { user } = store.state.userModule;
  try {
    const res = await api2.post(`client/${user.id}/izipay/session`);
    return res.data.data;
  } catch (error) {
    console.error(error.response);
    throw new Error(error.response?.data?.message || "No se pudo iniciar el registro con Izipay.");
  }
};

const confirmIzipayCard = async (data) => {
  const { user } = store.state.userModule;
  try {
    const res = await api2.post(`client/${user.id}/izipay/confirm`, data);
    return res.data;
  } catch (error) {
    Sentry.configureScope((scope) => {
      scope.setTransactionName("ConfirmIzipayCardError");
      scope.setLevel("error");
      scope.setExtra("response", JSON.stringify(error.response));
      Sentry.captureException(new Error("Failed Confirm Izipay Card"));
    });
    console.error(error.response);
    throw new Error(error.response?.data?.message || "No se pudo guardar la tarjeta.");
  }
};

// eslint-disable-next-line import/prefer-default-export
export { getIzipaySession, confirmIzipayCard };
